import { Container, Row, Col } from "react-bootstrap";
import TabMenu from "./TabMenu";
import { Outlet, useParams } from "react-router-dom";
import PomoCustomer from "./PromotionCustomer/Promo";

const Tab6 = () => { 
  const { Id } = useParams();

  return (
    <Container fluid className="dashboard">
      <Row className="g-4">
        <Col md={4} lg={3} className="p-2">
          <TabMenu />
        </Col>

        {/* Main Content */}
        <Col xs={12} md={8} lg={9}>
          {Id ? <Outlet /> : <PomoCustomer/>}
        </Col>
      </Row>
    </Container>
  );
};

export default Tab6;

  /* // {
  //   label: "Profile",
  //   icon: <FaUser />,
  //   subMenu: [
  //     { label: "View Profile", path: "/user/profile", icon: <FaIdBadge /> },
  //     { label: "Edit Profile", path: "/user/edit-profile", icon: <FaEdit /> },
  //     { label: "Change Password", path: `/changepassword/${id}`, icon: <FaKey /> },
  //     // { label: "Logout", action: "logout", icon: <FaSignOutAlt /> },
  //   ],
  // }, */